export default __webpack_public_path__ + "static/media/TopicsLogoBackground.b3945561.svg";